export const transformObjectToOptionsArray = obj =>
	Object.entries(obj).map(([value, label]) => ({
		label,
		value: Number.parseInt(value)
	}))
